import React, { useEffect } from "react";
import PropTypes from "prop-types";
import FacilityCard from "components/search/FacilityCards/FacilityCard";
import SearchToolbar from "components/search/SearchToolbar/SearchToolbar";
import { TrackingClient } from "@sparefoot/tracking-client";
import { useLocation } from "react-router";

const FacilityCards = ({ cards, layout, totalListings }) => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const searchTerm = searchParams.get("location");

	useEffect(() => {
		const facilitiesList = cards.map((facility) => facility.id) || [];
		const facilities =
			cards.map((facility, index) => ({
				id: facility.id,
				name: facility.name,
				address: facility.address,
				facility_rank: index + 1
			})) || [];
		TrackingClient.trackFacilityListViewed({
			facilities,
			facilities_list: facilitiesList,
			search_term: searchTerm
		});
	}, [cards]);

	return (
		<>
			{cards.map((facility, index) => (
				<React.Fragment key={facility.id}>
					<FacilityCard
						layout={layout}
						{...facility}
					/>
					{index + 1 < cards.length && (index + 1) % 20 === 0 && (
						<SearchToolbar
							className="search-toolbar divider"
							count={totalListings}
							currentRange={`${index + 2}-${
								index + 21 > totalListings
									? totalListings
									: index + 21
							}`}
							showSortSelect={false}
						/>
					)}
				</React.Fragment>
			))}
		</>
	);
};

FacilityCards.propTypes = {
	cards: PropTypes.arrayOf(PropTypes.object),
	layout: PropTypes.oneOf(["wide", "narrow"]),
	totalListings: PropTypes.number
};

export default FacilityCards;
